import {
  AssociatedContact,
  IAssociatedContact,
} from '@app/models/AssociatedContact'
import {
  actionCreators,
  IGlobalCompanyContactsState,
} from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import Select, { SingleValue } from 'react-select'

export interface IAssociatedContactSelectorProps {
  className?: string
  name?: string
  onChange: (newValue?: AssociatedContact) => void
  placeholder?: string
  required?: boolean
  style?: React.CSSProperties
  value: IAssociatedContact | undefined
}

type AssociatedContactSelectorProps = IAssociatedContactSelectorProps &
  IGlobalCompanyContactsState &
  typeof actionCreators

export class AssociatedContactSelector extends React.PureComponent<
  AssociatedContactSelectorProps
> {
  private selectRef: React.RefObject<HTMLDivElement>

  constructor(props: AssociatedContactSelectorProps) {
    super(props)
    this.selectRef = React.createRef()
    bindFunctions(this)
  }

  public componentDidMount() {
    // Force contacts list to be reloaded.
    this.props.getCompanyContactsList(true)
    this._checkValidity()
  }

  public componentDidUpdate() {
    this._checkValidity()
  }

  public render() {
    return (
      <div className={this.props.className} ref={this.selectRef}>
        <Select
          getOptionLabel={(o) => o.name}
          getOptionValue={(o) => o.contactId}
          onChange={this._onChange}
          options={this.props.companyContacts.results.toArray()}
          placeholder={this.props.placeholder || 'Add connections...'}
          required={this.props.required}
          value={this.props.value}
        />
      </div>
    )
  }

  private _checkValidity() {
    if (this.selectRef.current) {
      const inputElem = this.selectRef.current.querySelector('input:invalid')
      if (inputElem) {
        this.selectRef.current.classList.add('invalid')
      } else {
        this.selectRef.current.classList.remove('invalid')
      }
    }
  }

  private _onChange(newValue: SingleValue<IAssociatedContact>) {
    this.props.onChange((newValue as AssociatedContact) || undefined)
  }
}
